<template>
  <div class="ybbj-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  ref="table"
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="tcf-table-expand">
                        <el-form-item label="部件条码">
                          <span>{{ props.row.bar }}</span>
                        </el-form-item>
                        <el-form-item label="所在包装">
                          <span>{{ props.row.packnum }}</span>
                        </el-form-item>
                        <el-form-item label="包号">
                          <span>{{ props.row.packxuhao }}</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="生产单号">
                          <span>{{ props.row.produnum }}</span>
                        </el-form-item>
                        <el-form-item label="订单号">
                          <span>{{ props.row.ordernum }}</span>
                        </el-form-item>
                        <el-form-item label="入库状态">
                          <el-tag size="mini" :disable-transitions="true" v-if="props.row.imark===1">已入库</el-tag>
                          <el-tag size="mini" :disable-transitions="true" type="danger" v-if="props.row.imark===0">未入库</el-tag>
                        </el-form-item>
                        <br>
                        <el-form-item label="序号">
                          <span>{{ props.row.xuhao }}</span>
                        </el-form-item>
                        <el-form-item label="区域">
                          <span>{{ props.row.area }}</span>
                        </el-form-item>
                        <el-form-item label="分类">
                          <span>{{ props.row.type }}</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="名称">
                          <span>{{ props.row.name }}</span>
                        </el-form-item>
                        <el-form-item label="基材">
                          <span>{{ props.row.material }}</span>
                        </el-form-item>
                        <el-form-item label="规格">
                          <span v-if="props.row.high!=null&&props.row.high!=''">{{props.row.high}}</span>
                          <span v-if="props.row.high!=null&&props.row.high!=''">×</span>
                          <span v-if="props.row.width!=null&&props.row.width!=''">{{props.row.width}}</span>
                          <span v-if="props.row.width!=null&&props.row.width!=''">×</span>
                          <span v-if="props.row.ply!=null&&props.row.ply!=''">{{props.row.ply}}</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="颜色">
                          <span>{{ props.row.color }}</span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="bar" label="条码" align="center" show-overflow-tooltip width="160"></el-table-column>
                  <el-table-column prop="xuhao" label="序号" show-overflow-tooltip width="120"></el-table-column>
                  <el-table-column prop="area" label="区域" show-overflow-tooltip width="140"></el-table-column>
                  <el-table-column prop="type" label="分类" align="center" show-overflow-tooltip width="120"></el-table-column>
                  <el-table-column prop="name" label="名称" show-overflow-tooltip min-width="130"></el-table-column>
                  <el-table-column
                    label="包标签号"
                    width="180"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.packnum}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包号"
                    width="90"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.packxuhao}}
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="sizes, prev, pager, next"
                  >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderPackagedPartsList } from '@/api/erp'

export default {
  name: 'ybbj',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getErpOrderPackagedPartsList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$refs.table.toggleRowExpansion(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.ybbj-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
